export default "__VITE_ASSET__p_8dzmGl__"